<span class="trustee-main-contact">
  <app-contact-view [ref]="contactRef$ | async"
                    [hidden]="(contactRef$ | async) == null"
  ></app-contact-view>
</span>
